import { render, staticRenderFns } from "./RecordModel.vue?vue&type=template&id=5d5a2d7c&scoped=true"
import script from "./RecordModel.vue?vue&type=script&lang=js"
export * from "./RecordModel.vue?vue&type=script&lang=js"
import style0 from "./RecordModel.vue?vue&type=style&index=0&id=5d5a2d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5a2d7c",
  null
  
)

export default component.exports